<template>
	<div class="goodsview">
		<div @click="ActionFun($event)">
			<slot name="title">添加摘要信息</slot>
		</div>
		<VsModal width="1000px" top="80" v-model="modelstep" @on-confirm="fnModelConfirm">
			<div slot="header">
				<span>摘要信息</span>
			</div>
			<div slot="content" v-cloak>
				<Vstabs value="name1">
					<pane label="基本信息" name="name1">
						<div class="modelbox">
							<div class="itemleft">
								<div class="infowrap" @keyup.enter="enterToTab()">
									<li class="itemwrap" style='width:100%'>
										
											<Vsinput lable="摘要" v-model="infolist.Remark" lablecolor="red"
												lablewidth="100" width="400" validation=true  multiple></Vsinput>
									
									</li>
								</div>
						</div>
							

						</div>
					</pane>
				
				</Vstabs>
				</div>

			<div class="btnwrap" slot="footer">
				<Button @click="modelstep=false" type="default" size="large" style="width: 80px;">取消</Button>
				<Button @click="fnModelConfirm" type="primary" size="large"
					style="margin:0 20px;width: 100px;">确定</Button>
			</div>
		</VsModal>
	</div>
</template>

<script>
	
	export default {
		props: {
			info: {}, //修改信息
			category: {}, //类别信息
		},
		data() {
			return {
				
				lablewidth: '100',
				modelstep: false,

				infolist: {
					Remark: '', //	 必输项
				    ROOT:''
				}
			}
		},
		computed: {

		},
		mounted() {
			if (this.info) {
				this.infolist = this.info
			}
		},
		methods: {
		

			ActionFun($event) {
				this.modelstep = !this.modelstep
				if (this.info) {
					this.infolist = this.info
				}
				if (this.category) {
					this.infolist.leibie = this.category.name
					this.infolist.ROOT = this.category.CategoryID
				}
				
			},
			
			fnCreatRemark() {
				//this.$fun.GetUserConstant()
				var userinfo = this.$fun.GetUserConstant()
				console.log(userinfo)
				
				if (this.category) {
					userinfo.ROOT = this.category.CategoryID
				}
				let params = Object.assign({}, this.infolist, userinfo)
				if (this.info) {
					this.$Api.ErpEditRemark(params).then((res) => {
						console.log(res)
						if (res.status == 'SUCCESS') {
							this.$XModal.alert('修改成功！')
							this.modelstep = false
							this.$emit('on-confirm', this.infolist)
						} else {
							this.$XModal.alert(res.msg)
						}
					})
				} else {
					this.$Api.ErpAddRemark(params).then((res) => {
						console.log(res)
						if (res.status == 'SUCCESS') {
							this.$XModal.alert('添加成功！')
							Object.keys(this.infolist).forEach(v => {
								this.infolist[v] = ""
							})
							this.$emit('on-confirm', this.infolist)
						} else {
							this.$XModal.alert(res.msg)
						}
					})
				}
			},
 filterStr(str){
            let that = this;
            var specialStr = "";
		for(var i=0;i<str.length;i++){
	        specialStr += str.substr(i, 1).replace(/[`~!@#$^&*()=|{}':;',\[\].<>\/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？%+_]/, ''); 
        }
	    return specialStr;
   } ,
			//提交数据
			fnModelConfirm() {
				let myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
				if (this.infolist.Remark.match(/^[ ]*$/)) {
					this.$XModal.message({
						message: '摘要不能为空！',
						status: 'warning'
					});
					return
				}
				
				this.$Modal.confirm({
					title: this.info ? '确定修改信息吗？' : '确定添加信息吗？',
					onOk: () => {
					
							this.fnCreatRemark()
						

					}
				})
			},
			fnSwitchChange(e) {
				console.log(e)
				console.log(this.infolist.Remark)
			},
			

		}
	}
</script>

<style lang="less" scoped>
	.goodsview {
		display: flex;

		.modelbox {
			width: 100%;
			flex-wrap: wrap;

			.itemleft {
				width: 100%;
			}

			.itemright {
				width: 100%;
			}

			.infowrap {
				width: 100%;
				height: 65px;
				display: flex;
				font-size: 14px;
				align-items: center;
				color: #000;

				.itemwrap {
					width: 40%;
					display: flex;
				}

				.itemwrap>div {
					margin-left: 100px;
				}

				.itemdesc {
					color: red;
				}
			}
		}
	
	.imgbox {
			width: 100%;

			.imgwrap {
				display: flex;

				.imgicon {
					width: 100px;
					height: 100px;
					background: #ccc;
					margin: 10px;
					display: flex;
					justify-content: center;
					align-items: center;
					border-radius: 5px;
					position: relative;


					.delate {
						display: flex;
						align-items: center;
						justify-content: center;
						position: absolute;
						background: #919191;
						right: -10px;
						top: -10px;
						color: #fff;
						font-size: 20px;
						border-radius: 100%;
						cursor: pointer;
					}

					input {
						width: 100%;
						height: 100%;
						opacity: 0;
						//	background: #0000FE;
						cursor: pointer;
					}


				}

				.imgitem {
					width: 100%;
					height: 100%;
					Background-size: 100% !important
				}

				.addinput {
					width: 100px;
					height: 100px;
					border: 1px solid #ccc;
					margin: 10px;
					display: flex;
					//justify-content: center;
					align-items: center;
					border-radius: 5px;
					position: relative;
					//z-index: -1;
					//font-size: 80px;
					background: url(../../../assets/img/add.png) no-repeat center center;
					background-size: cover;

					.inputs {
						width: 100%;
						height: 100%;
						opacity: 0;
						//background: #006680;
					}
				}

			}
		}
.inputItem{
	width:100%
}
		.btnsumit {
			width: 150px;
			height: 35px;
			background: green;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 16px;
			color: #fff;
			border-radius: 5px;
			cursor: pointer;
			-webkit-user-select: none;
		}

		.btnwrap {
			height: 60px;
			//background: #006680;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}
</style>
